import { render } from "./ArrowDownSvg.vue?vue&type=template&id=1b5c7f4c&scoped=true"
const script = {}

import "./ArrowDownSvg.vue?vue&type=style&index=0&id=1b5c7f4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5c7f4c"]])

export default __exports__